import { useScrollAnimation } from '@/hooks/useScrollAnimation';

const testimonials = [
  {
    quote: 'Capital Area Signs transformed our storefront completely. The channel letter sign they designed and installed is absolutely stunning at night — exactly what we envisioned. Professional from the first consultation to the final install.',
    name: 'Austin Business Owner',
    company: 'Retail Storefront, Austin TX',
    service: 'Channel Letter Sign',
    stars: 5,
  },
  {
    quote: 'We needed vehicle wraps for our entire fleet of 8 trucks. Capital Area Signs handled the design, printing, and installation flawlessly. Our brand is now visible all over Central Texas. Turnaround was faster than expected.',
    name: 'Fleet Operations Manager',
    company: 'Commercial Services, Round Rock TX',
    service: 'Fleet Vehicle Wraps',
    stars: 5,
  },
  {
    quote: 'The monument sign for our office complex is incredible. They managed the entire permitting process, which I was dreading. No delays, no headaches — just a beautiful, professional sign that our tenants love.',
    name: 'Property Manager',
    company: 'Commercial Real Estate, Cedar Park TX',
    service: 'Monument Sign',
    stars: 5,
  },
];

export default function TestimonialsSection() {
  const { ref, visible } = useScrollAnimation();

  return (
    <section className="py-28 bg-[#F4EFE5] relative overflow-hidden">
      {/* Background texture */}
      <div className="absolute inset-0 opacity-3"
        style={{ backgroundImage: 'repeating-linear-gradient(45deg, #C4962A 0, #C4962A 1px, transparent 0, transparent 50%)', backgroundSize: '24px 24px' }} />

      <div className="relative z-10 max-w-7xl mx-auto px-8">
        {/* Header */}
        <div ref={ref} className={`flex flex-col md:flex-row md:items-end justify-between mb-16 gap-6 reveal ${visible ? 'visible' : ''}`}>
          <div>
            <p className="eyebrow mb-4">Client Results</p>
            <h2 className="text-5xl md:text-6xl font-bold text-[#111111] leading-tight"
              style={{ fontFamily: 'Playfair Display, serif' }}>
              What Our Clients<br />
              <em className="not-italic text-gradient-gold">Say About Us</em>
            </h2>
          </div>
          <div>
            <span className="gold-bar mb-4 block" />
            <div className="flex items-center gap-2 mb-2">
              {[...Array(5)].map((_, i) => (
                <i key={i} className="ri-star-fill text-[#C4962A] text-lg" />
              ))}
            </div>
            <p className="text-[#666666] text-sm font-semibold">5.0 Average Rating</p>
            <a href="https://www.google.com/search?q=Capital+Area+Signs+Austin+TX+reviews"
              target="_blank" rel="nofollow noopener"
              className="text-[#C4962A] text-xs font-bold uppercase tracking-widest hover:underline cursor-pointer mt-1 block">
              View Google Reviews →
            </a>
          </div>
        </div>

        {/* Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div key={i}
              className={`bg-[#111111] p-8 card-lift cursor-pointer reveal delay-${i * 100} ${visible ? 'visible' : ''}`}
              style={{ borderTop: '3px solid #C4962A' }}>
              {/* Stars */}
              <div className="flex gap-1 mb-6">
                {[...Array(t.stars)].map((_, s) => (
                  <i key={s} className="ri-star-fill text-[#C4962A] text-sm" />
                ))}
              </div>

              {/* Quote mark */}
              <div className="text-[#C4962A]/15 text-7xl leading-none mb-2 -mt-2"
                style={{ fontFamily: 'Playfair Display, serif' }}>&ldquo;</div>

              {/* Quote */}
              <p className="text-white/70 text-sm leading-relaxed mb-8 italic">
                {t.quote}
              </p>

              {/* Service tag */}
              <div className="mb-6">
                <span className="text-xs text-[#C4962A] border border-[#C4962A]/30 px-2.5 py-1 uppercase tracking-widest font-bold">
                  {t.service}
                </span>
              </div>

              {/* Author */}
              <div className="flex items-center gap-3 border-t border-white/8 pt-5">
                <div className="w-10 h-10 rounded-full bg-[#C4962A]/15 flex items-center justify-center flex-shrink-0">
                  <i className="ri-user-3-fill text-[#C4962A] text-sm" />
                </div>
                <div>
                  <p className="text-white text-sm font-bold">{t.name}</p>
                  <p className="text-white/35 text-xs">{t.company}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
